<mat-card appearance="outlined">
  <mat-card-header class="flex justify-between">
    <mat-card-title>SMS Communication</mat-card-title>
    <mat-card-subtitle>
      Send SMS messages with your preferred provider
    </mat-card-subtitle>

    <div *ngrxLet="providerIsUnsaved$ as unsaved" class="flex flex-col gap-2">
      <div class="flex flex-row items-center gap-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>SMS Integration Provider</mat-label>
          <mat-select [formControl]="smsProviderCtrl">
            @for (provider of smsProviders$ | async; track provider) {
              <mat-option [value]="provider">
                {{ provider | map: getProviderName$ : this | async }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button
          mat-flat-button
          color="primary"
          [disabled]="!unsaved"
          (click)="saveSMSPreference()"
        >
          Save
        </button>
      </div>
      @if (unsaved) {
        <span class="text-warn-500 mat-caption">
          @if (selectedProvider$ | async; as provider) {
            Provider is currently set to
            {{ provider | splitCamel | titlecase }}
          } @else {
            No Provider Saved
          }
        </span>
      }
    </div>
  </mat-card-header>

  <mat-card-content *ngrxLet="savedProvider$ as savedProvider" class="mt-2">
    @switch (selectedProvider$ | async) {
      @case ('twilio') {
        <pr-manage-twilio-integration
          [organisation]="organisation$ | async"
          [region]="region$ | async"
          [integrationsCol]="integrationsCol()"
          [savedProvider]="savedProvider"
          (providerChanged)="promptForProviderChange($event)"
        />
      }
      @case ('podium') {
        <pr-manage-podium-integration
          [orgUid]="orgUid$ | async"
          [integrationsCol]="integrationsCol()"
          [temporaryTokensCol]="temporaryTokensCol()"
        />
      }
      @case ('tnz') {
        <pr-manage-tnz-integration
          [integrationsCol]="integrationsCol()"
          [orgSlug]="orgSlug$ | async"
          [region]="region$ | async"
          [savedProvider]="savedProvider"
          (providerChanged)="promptForProviderChange($event)"
        />
      }
      @case ('viaApi') {
        <pr-manage-via-api-integration
          [integrationsCol]="integrationsCol()"
          [savedProvider]="savedProvider"
          (providerChanged)="promptForProviderChange($event)"
        />
      }
      @default {
        <pr-empty-state image="list" title="communication provider selected" />
      }
    }
  </mat-card-content>
</mat-card>
